var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"Stats"},_vm._l((_vm.roundedStats),function(stat,key){return _c('li',{key:key,staticClass:"Stats__item"},[_c('img',{attrs:{"src":require(("@/assets/" + key + ".png")),"alt":key}}),_c('strong',{class:{
        warning: stat < 50,
        danger: stat < 20,
      }},[_vm._v(" "+_vm._s(stat)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }